var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "form-request" }, [
    _c("div", { staticClass: "form-request__wrapper" }, [
      _c(
        "form",
        {
          ref: "form_request",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-request__date" },
            [
              _c("BaseCaption", {
                attrs: { text: _vm.form.captions[0].text, tag: "h3" }
              }),
              _c("div", { staticClass: "form-request__date-items" }, [
                _c(
                  "div",
                  { staticClass: "form-request__date-item" },
                  [
                    _c("BaseLabel", {
                      attrs: {
                        required: _vm.form.fields[0].required,
                        text: _vm.form.fields[0].label
                      }
                    }),
                    _c("no-ssr", [
                      _c(
                        "div",
                        { staticClass: "data-picker" },
                        [
                          _c("test", {
                            attrs: {
                              language: _vm.language,
                              format: "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.formData.date,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "date", $$v)
                              },
                              expression: "formData.date"
                            }
                          }),
                          _c("div", { staticClass: "data-picker__svg" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 512 512"
                                }
                              },
                              [
                                _c("defs"),
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M462 44h-47.667V30c0-16.542-13.458-30-30-30s-30 13.458-30 30v14h-168V30c0-16.542-13.458-30-30-30s-30 13.458-30 30v14.37c-.85-.235-1.741-.37-2.666-.37H83.823c-27.57 0-50 22.43-50 50v170.333c0 5.523 4.478 10 10 10s10-4.477 10-10V147h360.51c5.522 0 10-4.477 10-10s-4.478-10-10-10H53.823V94c0-16.542 13.458-30 30-30h39.844c.925 0 1.816-.136 2.666-.37V76.5c0 16.542 13.458 30 30 30s30-13.458 30-30V64h168v12.5c0 16.542 13.458 30 30 30s30-13.458 30-30V64H462c16.542 0 30 13.458 30 30v379.994c0 9.928-8.077 18.006-18.006 18.006s-18.006-8.078-18.006-18.006v-25.869c0-5.523-4.478-10-10-10H329.667c-5.522 0-10 4.477-10 10s4.478 10 10 10h106.321v15.869c0 6.511 1.648 12.643 4.545 18.006H38c-9.925 0-18-8.075-18-18v-15.875h223.825c5.522 0 10-4.477 10-10s-4.478-10-10-10h-99.916c17.474-15.049 28.57-37.309 28.57-62.125 0-45.215-36.785-82-82-82s-82 36.785-82 82c0 24.816 11.096 47.076 28.57 62.125H10c-5.522 0-10 4.477-10 10V474c0 20.953 17.047 38 38 38h435.994C494.95 512 512 494.951 512 473.994V94c0-27.57-22.43-50-50-50zM166.333 76.5c0 5.514-4.486 10-10 10s-10-4.486-10-10V30c0-5.514 4.486-10 10-10s10 4.486 10 10v46.5zm228 0c0 5.514-4.486 10-10 10s-10-4.486-10-10V30c0-5.514 4.486-10 10-10s10 4.486 10 10v46.5zM28.479 376c0-34.187 27.813-62 62-62s62 27.813 62 62-27.813 62-62 62-62-27.813-62-62z"
                                  }
                                }),
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M468.309 129.93c-1.859-1.86-4.439-2.93-7.069-2.93-2.631 0-5.21 1.07-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.069 5.21 2.93 7.07c1.861 1.86 4.439 2.93 7.07 2.93 2.63 0 5.21-1.07 7.069-2.93 1.86-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07zM298.649 441.05c-1.859-1.86-4.439-2.92-7.069-2.92s-5.21 1.06-7.07 2.92c-1.86 1.87-2.93 4.44-2.93 7.07 0 2.64 1.069 5.21 2.93 7.08 1.86 1.86 4.44 2.92 7.07 2.92s5.21-1.06 7.069-2.92c1.86-1.87 2.931-4.45 2.931-7.08s-1.07-5.2-2.931-7.07zM226.245 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM319.578 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM412.912 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM132.912 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM319.578 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM412.912 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM226.245 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM126.104 351.629c-3.906-3.905-10.236-3.905-14.143 0l-32.566 32.567-11.129-11.129c-3.906-3.905-10.236-3.905-14.143 0-3.905 3.905-3.905 10.237 0 14.143l18.201 18.199c1.876 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l39.638-39.638c3.905-3.905 3.905-10.237 0-14.142z"
                                  }
                                })
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm.errors.date
                      ? _c("BaseErrorMessage", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.errors.date) +
                              "\n                "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "form-request__date-item" },
                  [
                    _c(
                      "BaseLabel",
                      {
                        attrs: {
                          required: _vm.form.fields[1].required,
                          text: _vm.form.fields[1].label
                        }
                      },
                      [
                        _c("BaseInput", {
                          attrs: {
                            name: _vm.form.fields[1].name,
                            type: _vm.form.fields[1].type
                          },
                          model: {
                            value: _vm.formData.label,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "label", $$v)
                            },
                            expression: "formData.label"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.errors.label
                      ? _c("BaseErrorMessage", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.errors.label) +
                              "\n                "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-request__concept" },
            [
              _c("BaseLabel", {
                attrs: {
                  required: _vm.form.fields[2].required,
                  text: _vm.form.fields[2].label
                }
              }),
              _c(
                "div",
                { staticClass: "form-request__concept-item" },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.description,
                        expression: "formData.description"
                      }
                    ],
                    attrs: { name: "description" },
                    domProps: { value: _vm.formData.description },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.formData,
                          "description",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm.errors.description
                    ? _c("BaseErrorMessage", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.errors.description) +
                            "\n                "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("BaseCaption", {
            attrs: { text: _vm.form.captions[8].text, tag: "h3" }
          }),
          _vm._l(_vm.form.work_type.items, function(item) {
            return _c(
              "div",
              {
                key: item.value,
                staticClass: "form-request__person-work_type"
              },
              [
                _c("BaseRadioSingle", {
                  attrs: { item: item, value: _vm.formData.work_type },
                  on: {
                    "update:value": function($event) {
                      return _vm.handleWorkTypeChange($event)
                    }
                  }
                }),
                _vm.formData.work_type === item.value
                  ? _c(
                      "div",
                      { staticClass: "form-request__person-external-images" },
                      [
                        _c("BaseCaption", {
                          attrs: {
                            text:
                              _vm.form.captions[
                                _vm.formData.work_type === "handmade" ? 9 : 10
                              ].text,
                            tag: "h6"
                          }
                        }),
                        _c("BaseRadio", {
                          attrs: {
                            value: _vm.formData.has_external_images,
                            items: _vm.form.has_external_images.items
                          },
                          on: {
                            "update:value": [
                              function($event) {
                                return _vm.$set(
                                  _vm.formData,
                                  "has_external_images",
                                  $event
                                )
                              },
                              _vm.handleHasExternalImagesChange
                            ]
                          }
                        }),
                        _vm.errors.has_external_images
                          ? _c("BaseErrorMessage", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.has_external_images) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          _c("div", { staticClass: "form-request__person" }, [
            _c(
              "div",
              { staticClass: "form-request__person-items" },
              [
                _c("BaseCaption", {
                  attrs: { text: _vm.form.captions[2].text, tag: "h3" }
                }),
                _c(
                  "div",
                  { staticClass: "form-request__person-item" },
                  [
                    _c(
                      "BaseLabel",
                      {
                        attrs: {
                          required: _vm.form.fields[3].required,
                          text: _vm.form.fields[3].label
                        }
                      },
                      [
                        _c("BaseInput", {
                          attrs: {
                            name: _vm.form.fields[3].name,
                            type: _vm.form.fields[3].type
                          },
                          model: {
                            value: _vm.formData.name,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.errors.name
                      ? _c("BaseErrorMessage", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.errors.name) +
                              "\n                  "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "form-request__person-item" },
                  [
                    _c(
                      "BaseLabel",
                      {
                        attrs: {
                          required: _vm.form.fields[4].required,
                          text: _vm.form.fields[4].label
                        }
                      },
                      [
                        _c("BaseInput", {
                          attrs: {
                            name: _vm.form.fields[4].name,
                            type: _vm.form.fields[4].type
                          },
                          model: {
                            value: _vm.formData.surname,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "surname", $$v)
                            },
                            expression: "formData.surname"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.errors.surname
                      ? _c("BaseErrorMessage", [
                          _vm._v(
                            "\n                      " +
                              _vm._s(_vm.errors.surname) +
                              "\n                    "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "form-request__person-item" },
                  [
                    _c(
                      "BaseLabel",
                      {
                        attrs: {
                          required: _vm.form.fields[5].required,
                          text: _vm.form.fields[5].label
                        }
                      },
                      [
                        _c("BaseInput", {
                          attrs: {
                            name: _vm.form.fields[5].name,
                            type: _vm.form.fields[5].type
                          },
                          model: {
                            value: _vm.formData.patronymic,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "patronymic", $$v)
                            },
                            expression: "formData.patronymic"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.errors.patronymic
                      ? _c("BaseErrorMessage", [
                          _vm._v(
                            "\n                      " +
                              _vm._s(_vm.errors.patronymic) +
                              "\n                    "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-request__person-items" },
              [
                _c("BaseCaption", {
                  attrs: { text: _vm.form.captions[3].text, tag: "h3" }
                }),
                _c("no-ssr", [
                  _c(
                    "div",
                    { staticClass: "data-picker" },
                    [
                      _c("test", {
                        attrs: { language: _vm.language, format: "yyyy-MM-dd" },
                        model: {
                          value: _vm.formData.birth,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "birth", $$v)
                          },
                          expression: "formData.birth"
                        }
                      }),
                      _c("div", { staticClass: "data-picker__svg" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 512 512"
                            }
                          },
                          [
                            _c("defs"),
                            _c("path", {
                              attrs: {
                                d:
                                  "M462 44h-47.667V30c0-16.542-13.458-30-30-30s-30 13.458-30 30v14h-168V30c0-16.542-13.458-30-30-30s-30 13.458-30 30v14.37c-.85-.235-1.741-.37-2.666-.37H83.823c-27.57 0-50 22.43-50 50v170.333c0 5.523 4.478 10 10 10s10-4.477 10-10V147h360.51c5.522 0 10-4.477 10-10s-4.478-10-10-10H53.823V94c0-16.542 13.458-30 30-30h39.844c.925 0 1.816-.136 2.666-.37V76.5c0 16.542 13.458 30 30 30s30-13.458 30-30V64h168v12.5c0 16.542 13.458 30 30 30s30-13.458 30-30V64H462c16.542 0 30 13.458 30 30v379.994c0 9.928-8.077 18.006-18.006 18.006s-18.006-8.078-18.006-18.006v-25.869c0-5.523-4.478-10-10-10H329.667c-5.522 0-10 4.477-10 10s4.478 10 10 10h106.321v15.869c0 6.511 1.648 12.643 4.545 18.006H38c-9.925 0-18-8.075-18-18v-15.875h223.825c5.522 0 10-4.477 10-10s-4.478-10-10-10h-99.916c17.474-15.049 28.57-37.309 28.57-62.125 0-45.215-36.785-82-82-82s-82 36.785-82 82c0 24.816 11.096 47.076 28.57 62.125H10c-5.522 0-10 4.477-10 10V474c0 20.953 17.047 38 38 38h435.994C494.95 512 512 494.951 512 473.994V94c0-27.57-22.43-50-50-50zM166.333 76.5c0 5.514-4.486 10-10 10s-10-4.486-10-10V30c0-5.514 4.486-10 10-10s10 4.486 10 10v46.5zm228 0c0 5.514-4.486 10-10 10s-10-4.486-10-10V30c0-5.514 4.486-10 10-10s10 4.486 10 10v46.5zM28.479 376c0-34.187 27.813-62 62-62s62 27.813 62 62-27.813 62-62 62-62-27.813-62-62z"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "M468.309 129.93c-1.859-1.86-4.439-2.93-7.069-2.93-2.631 0-5.21 1.07-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.069 5.21 2.93 7.07c1.861 1.86 4.439 2.93 7.07 2.93 2.63 0 5.21-1.07 7.069-2.93 1.86-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07zM298.649 441.05c-1.859-1.86-4.439-2.92-7.069-2.92s-5.21 1.06-7.07 2.92c-1.86 1.87-2.93 4.44-2.93 7.07 0 2.64 1.069 5.21 2.93 7.08 1.86 1.86 4.44 2.92 7.07 2.92s5.21-1.06 7.069-2.92c1.86-1.87 2.931-4.45 2.931-7.08s-1.07-5.2-2.931-7.07zM226.245 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM319.578 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM412.912 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM132.912 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM319.578 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM412.912 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM226.245 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM126.104 351.629c-3.906-3.905-10.236-3.905-14.143 0l-32.566 32.567-11.129-11.129c-3.906-3.905-10.236-3.905-14.143 0-3.905 3.905-3.905 10.237 0 14.143l18.201 18.199c1.876 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l39.638-39.638c3.905-3.905 3.905-10.237 0-14.142z"
                              }
                            })
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm.errors.birth
                  ? _c("BaseErrorMessage", [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.errors.birth) +
                          "\n                "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              staticClass: "form-request__person form-request__person_two-col"
            },
            [
              _c(
                "div",
                { staticClass: "form-request__person-gender" },
                [
                  _c("BaseCaption", {
                    attrs: { text: _vm.form.captions[4].text, tag: "h3" }
                  }),
                  _c("BaseRadio", {
                    attrs: {
                      value: _vm.formData.gender,
                      items: _vm.form.gender.items
                    },
                    on: {
                      "update:value": function($event) {
                        return _vm.$set(_vm.formData, "gender", $event)
                      }
                    }
                  }),
                  _vm.errors.gender
                    ? _c("BaseErrorMessage", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.gender) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "form-request__person-parents" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-request__person-parents-items form-request__person-parents-items_modify"
                  },
                  [
                    _c("BaseCaption", {
                      attrs: { text: _vm.form.captions[5].text, tag: "h3" }
                    }),
                    _c(
                      "div",
                      { staticClass: "form-request__person-item" },
                      [
                        _c(
                          "BaseLabel",
                          {
                            attrs: {
                              required: _vm.form.fields[6].required,
                              text: _vm.form.fields[6].label
                            }
                          },
                          [
                            _c("BaseInput", {
                              attrs: {
                                name: _vm.form.fields[6].name,
                                type: _vm.form.fields[6].type
                              },
                              model: {
                                value: _vm.formData.parent_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "parent_name", $$v)
                                },
                                expression: "formData.parent_name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.errors.parent_name
                          ? _c("BaseErrorMessage", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.errors.parent_name) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "form-request__person-item" },
                      [
                        _c(
                          "BaseLabel",
                          {
                            attrs: {
                              required: _vm.form.fields[7].required,
                              text: _vm.form.fields[7].label
                            }
                          },
                          [
                            _c("BaseInput", {
                              attrs: {
                                name: _vm.form.fields[7].name,
                                type: _vm.form.fields[7].type
                              },
                              model: {
                                value: _vm.formData.parent_surname,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "parent_surname", $$v)
                                },
                                expression: "formData.parent_surname"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.errors.parent_surname
                          ? _c("BaseErrorMessage", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.errors.parent_surname) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "form-request__person-item" },
                      [
                        _c(
                          "BaseLabel",
                          {
                            attrs: {
                              required: _vm.form.fields[8].required,
                              text: _vm.form.fields[8].label
                            }
                          },
                          [
                            _c("BaseInput", {
                              attrs: {
                                name: _vm.form.fields[8].name,
                                type: _vm.form.fields[8].type
                              },
                              model: {
                                value: _vm.formData.parent_patronymic,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "parent_patronymic",
                                    $$v
                                  )
                                },
                                expression: "formData.parent_patronymic"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.errors.parent_patronymic
                          ? _c("BaseErrorMessage", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.errors.parent_patronymic) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "form-request__person form-request__person_address"
            },
            [
              _c(
                "div",
                { staticClass: "form-request__person-items" },
                [
                  _c("BaseCaption", {
                    attrs: { text: _vm.form.captions[6].text, tag: "h3" }
                  }),
                  _c(
                    "div",
                    { staticClass: "form-request__person-item" },
                    [
                      _c(
                        "BaseLabel",
                        {
                          attrs: {
                            required: _vm.form.fields[9].required,
                            text: _vm.form.fields[9].label
                          }
                        },
                        [
                          _c("BaseInput", {
                            attrs: {
                              name: _vm.form.fields[9].name,
                              type: _vm.form.fields[9].type
                            },
                            model: {
                              value: _vm.formData.index,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "index", $$v)
                              },
                              expression: "formData.index"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.errors.index
                        ? _c("BaseErrorMessage", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.errors.index) +
                                "\n                  "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-request__person-item" },
                    [
                      _c(
                        "BaseLabel",
                        {
                          attrs: {
                            required: _vm.form.fields[10].required,
                            text: _vm.form.fields[10].label
                          }
                        },
                        [
                          _c("BaseInput", {
                            attrs: {
                              name: _vm.form.fields[10].name,
                              type: _vm.form.fields[10].type
                            },
                            model: {
                              value: _vm.formData.country,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "country", $$v)
                              },
                              expression: "formData.country"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.errors.country
                        ? _c("BaseErrorMessage", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.errors.country) +
                                "\n                  "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-request__person-item" },
                    [
                      _c(
                        "BaseLabel",
                        {
                          attrs: {
                            required: _vm.form.fields[11].required,
                            text: _vm.form.fields[11].label
                          }
                        },
                        [
                          _c("BaseInput", {
                            attrs: {
                              name: _vm.form.fields[11].name,
                              type: _vm.form.fields[11].type
                            },
                            model: {
                              value: _vm.formData.address,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "address", $$v)
                              },
                              expression: "formData.address"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.errors.address
                        ? _c("BaseErrorMessage", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.errors.address) +
                                "\n                  "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "form-request__person form-request__person_numbers"
            },
            [
              _c(
                "div",
                { staticClass: "form-request__person-items" },
                [
                  _c("BaseCaption", {
                    attrs: { text: _vm.form.captions[7].text, tag: "h3" }
                  }),
                  _c(
                    "div",
                    { staticClass: "form-request__person-item" },
                    [
                      _c(
                        "BaseLabel",
                        {
                          attrs: {
                            required: _vm.form.fields[12].required,
                            text: _vm.form.fields[12].label
                          }
                        },
                        [
                          _c("BaseInput", {
                            attrs: {
                              name: _vm.form.fields[12].name,
                              type: _vm.form.fields[12].type
                            },
                            model: {
                              value: _vm.formData.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "phone", $$v)
                              },
                              expression: "formData.phone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.errors.phone
                        ? _c("BaseErrorMessage", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.errors.phone) +
                                "\n                  "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-request__person-item" },
                    [
                      _c(
                        "BaseLabel",
                        {
                          attrs: {
                            required: _vm.form.fields[13].required,
                            text: _vm.form.fields[13].label
                          }
                        },
                        [
                          _c("BaseInput", {
                            attrs: {
                              name: _vm.form.fields[13].name,
                              type: _vm.form.fields[13].type
                            },
                            model: {
                              value: _vm.formData.email,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "email", $$v)
                              },
                              expression: "formData.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.errors.email
                        ? _c("BaseErrorMessage", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.errors.email) +
                                "\n                  "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "form-request__btns" },
            [
              _c("BaseBtn", {
                staticClass: "form-request__btn",
                attrs: {
                  type: "submit",
                  customClass: "default",
                  text: _vm.form.submitBtn.text
                }
              }),
              _vm.pdfData
                ? _c("BaseBtn", {
                    staticClass: "form-request__btn",
                    attrs: {
                      customClass: "default",
                      to: _vm.pdfData,
                      target: "_blank",
                      text: "Отримати заявку учасника"
                    }
                  })
                : _vm._e(),
              _vm.pdfDataPatent
                ? _c("BaseBtn", {
                    staticClass: "form-request__btn",
                    attrs: {
                      customClass: "default",
                      to: _vm.pdfDataPatent,
                      target: "_blank",
                      text: "Отримати диплом учасника"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf0124c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf0124c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FormRequest.vue
// module id = pHH5
// module chunks = 8